import { Amount } from '@sky-distribution/adapter-core-pc-rest-interfaces';
import { Variant } from '@sky-distribution/digital-gp-submission';
import { formatPriceWithCurrency } from '@sky-distribution/gp-onboarding-shared-utils';
import { TFunction } from 'i18next';
import { CoverageWithMeta } from '../Coverage.type';
import { DEFAULT_CURRENCY } from '../config/const';
import { getSelectedCoverages } from './filter';
import { getCoverageOptions } from './options';

export const getTotalPrice = (
  coverages: CoverageWithMeta[],
  currency: Amount['currency'] = 'pln',
  digitalSubmissionVariant?: Variant,
): Amount & { preDiscountAmount?: number } => {
  const variantAmount = digitalSubmissionVariant?.price?.amount;

  if (
    digitalSubmissionVariant
    && typeof variantAmount === 'number'
    && Number.isFinite(variantAmount)
    && variantAmount > 0
  ) {
    const variantCurrency = digitalSubmissionVariant.price?.currency;
    const normalizedCurrency = typeof variantCurrency === 'string'
      ? variantCurrency.toLowerCase()
      : undefined;

    return {
      amount: variantAmount,
      preDiscountAmount: digitalSubmissionVariant.price?.preDiscountAmount,
      currency: (normalizedCurrency ?? currency) as Amount['currency'],
    };
  }

  const selectedCoverages = getSelectedCoverages(coverages);

  const totalPrice = selectedCoverages.reduce<number>((totalAmount, { coverage }) => {
    const currentAmount = coverage.amount?.amount ?? 0;
    const impreciseSum = totalAmount + currentAmount;
    const preciseSum = Number.parseFloat(impreciseSum.toFixed(2));

    return preciseSum;
  }, 0);

  return {
    amount: totalPrice,
    currency,
  };
};

export const getTermPrice = (
  code: string,
  coveragesWithMeta: CoverageWithMeta[],
  t: TFunction,
  showCurrency = true,
): string | undefined => {
  const coverage = coveragesWithMeta.find(({ codeIdentifier }) => codeIdentifier === code);

  if (coverage) {
    const { options, chosenTermValue } = getCoverageOptions(coverage.coverage, t);
    const price = chosenTermValue || options?.[0]?.label;
    const currency = coverage.termCurrency
      || coverage.coverage.currency
      || coverage.coverage.amount?.currency
      || DEFAULT_CURRENCY;

    return showCurrency
      ? formatPriceWithCurrency(price, t(`offer:Currency.${currency}`, { defaultValue: currency }))
      : Number(price)
        .toString();
  }

  return undefined;
};
